// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer */
/* Color tokens now come from Technum.css (:root) as --technum-* */
.technumopus-footer {
  background: var(--technum-navy);
  color: rgba(255, 255, 255, 0.8);
  padding: var(--section-padding) var(--container-padding);
  font-size: var(--body-regular);
}

.technumopus-footer .technumopus-container {
  max-width: 1440px;
  margin: 0 auto;
}

.technumopus-footer .technumopus-footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1.5fr;
  gap: 48px;
  margin-bottom: 40px;
}

.technumopus-footer .technumopus-footer-brand p {
  line-height: 1.6;
  margin-bottom: 20px;
}

.technumopus-footer .technumopus-footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {
  width: 200px;
  height: auto;
}

.technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.technumopus-footer .technumopus-contact-info {
  margin-bottom: 24px;
  font-size: 0.8125rem;
}

.technumopus-footer .technumopus-contact-info p {
  margin-bottom: 6px;
  line-height: 1.5;
}

.technumopus-footer .technumopus-contact-info strong {
  color: var(--technum-white);
  font-weight: 600;
}

.technumopus-footer .technumopus-contact-info a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.technumopus-footer .technumopus-contact-info a:hover {
  color: var(--technum-teal);
}

.technumopus-footer .technumopus-contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.technumopus-footer .technumopus-contact-icon {
  width: 18px;
  height: 19px;
  flex-shrink: 0;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.technumopus-footer .technumopus-contact-item:hover .technumopus-contact-icon {
  opacity: 1;
}

.technumopus-footer .technumopus-social-links {
  display: flex;
  gap: 16px;
}

.technumopus-footer .technumopus-social-links a {
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.3s ease;
}

.technumopus-footer .technumopus-social-links a:hover {
  color: var(--technum-white);
}

.technumopus-footer .technumopus-footer-section h4 {
  color: var(--technum-white);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 600;
  margin-bottom: 20px;
  font-size: var(--body-large);
}

.technumopus-footer .technumopus-footer-section ul {
  list-style: none;
  line-height: 2;
  padding: 0;
  margin: 0;
}

.technumopus-footer .technumopus-footer-section a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: var(--body-regular);
  display: block;
  padding: 6px 6px 6px 10px;
  white-space: nowrap;
  position: relative;
  border-left: 4px solid transparent;
}

.technumopus-footer .technumopus-footer-section a:hover {
  color: var(--technum-white);
  background: rgba(0, 168, 150, 0.15);
  border-left-color: var(--technum-teal);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  white-space: nowrap;
}

/* Quick Contact Form — sizing/layout overrides; visuals live in Forms.css */
.technumopus-footer .technumopus-quick-form { width: 100%; }

.technumopus-footer .technumopus-footer-aws {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 0;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.technumopus-footer .technumopus-footer-aws-left {
  display: flex;
  align-items: center;
  gap: 18px;
  flex: 1 1 auto;
  min-width: 0;
}

.technumopus-footer .technumopus-footer-aws-logo {
  height: 36px;
  width: auto;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
  opacity: 0.95;
}

.technumopus-footer .technumopus-footer-aws-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.technumopus-footer .technumopus-footer-aws-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--technum-white);
  letter-spacing: 0.01em;
}

.technumopus-footer .technumopus-footer-aws-desc {
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.technumopus-footer .technumopus-footer-aws-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 999px;
  background: rgba(0, 168, 150, 0.12);
  border: 1px solid rgba(0, 168, 150, 0.4);
  color: var(--technum-white);
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.3s ease, border-color 0.3s ease, transform 0.2s ease;
  flex-shrink: 0;
}

.technumopus-footer .technumopus-footer-aws-cta:hover {
  background: rgba(0, 168, 150, 0.22);
  border-color: rgba(0, 168, 150, 0.7);
  transform: translateX(2px);
}

@media (max-width: 600px) {
  .technumopus-footer .technumopus-footer-aws {
    flex-direction: column;
    align-items: flex-start;
  }
  .technumopus-footer .technumopus-footer-aws-cta {
    align-self: stretch;
    justify-content: center;
  }
}

.technumopus-footer .technumopus-footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.technumopus-footer .technumopus-footer-bottom p {
  font-size: var(--body-small);
  margin: 0;
}

.technumopus-footer .technumopus-footer-links {
  display: flex;
  gap: 12px;
  font-size: var(--body-small);
}

.technumopus-footer .technumopus-footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-block;
}

.technumopus-footer .technumopus-footer-links a:hover {
  color: var(--technum-white);
  background: rgba(0, 168, 150, 0.1);
}

/* Responsive */

/* Large Laptops/Desktops (1440px and above) */

/* Tablets (769px - 1024px) */
@media (max-width: 1024px) {
  .technumopus-footer .technumopus-container {
    padding: 0 var(--container-padding);
  }

  .technumopus-footer .technumopus-footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    margin-bottom: 32px;
  }

  .technumopus-footer .technumopus-footer-brand {
    grid-column: span 2;
  }

  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {
    width: 160px;
  }

  .technumopus-footer .technumopus-contact-icon {
    width: 16px;
    height: 16px;
  }

  .technumopus-footer .technumopus-social-links {
    gap: 12px;
  }

  .technumopus-footer .technumopus-social-links a svg {
    width: 20px;
    height: 20px;
  }

  .technumopus-footer .technumopus-footer-section a {
    padding: 5px 5px 5px 8px;
  }

  .technumopus-footer .technumopus-footer-bottom {
    padding-top: 24px;
    flex-direction: column;
    text-align: center;
  }
}

/* Mobile Landscape and Smaller Tablets (481px - 768px) */
@media (max-width: 768px) {
  .technumopus-footer .technumopus-container {
    padding: 0 var(--container-padding);
  }

  .technumopus-footer .technumopus-footer-content {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-bottom: 24px;
  }

  .technumopus-footer .technumopus-footer-brand {
    grid-column: span 1;
  }

  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {
    width: 140px;
  }

  .technumopus-footer .technumopus-contact-icon {
    width: 14px;
    height: 14px;
  }

  .technumopus-footer .technumopus-social-links {
    gap: 10px;
  }

  .technumopus-footer .technumopus-social-links a svg {
    width: 18px;
    height: 18px;
  }

  .technumopus-footer .technumopus-footer-section a {
    padding: 4px 4px 4px 6px;
  }

  .technumopus-footer .technumopus-footer-bottom {
    padding-top: 20px;
  }
}

/* Mobile Portrait (480px and below) */
@media (max-width: 480px) {
  .technumopus-footer .technumopus-container {
    padding: 0 var(--container-padding);
  }

  .technumopus-footer .technumopus-footer-content {
    gap: 20px;
    margin-bottom: 20px;
  }

  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {
    width: 120px;
  }

  .technumopus-footer .technumopus-contact-icon {
    width: 12px;
    height: 12px;
  }

  .technumopus-footer .technumopus-social-links {
    gap: 8px;
  }

  .technumopus-footer .technumopus-social-links a svg {
    width: 16px;
    height: 16px;
  }

  .technumopus-footer .technumopus-footer-section a {
    padding: 3px 3px 3px 5px;
  }

  .technumopus-footer .technumopus-footer-bottom {
    padding-top: 16px;
    gap: 12px;
  }
}

/* Small Mobile Phones (360px and below) */
@media (max-width: 360px) {
  .technumopus-footer .technumopus-container {
    padding: 0 var(--container-padding);
  }

  .technumopus-footer .technumopus-footer-content {
    gap: 16px;
    margin-bottom: 16px;
  }

  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {
    width: 100px;
  }

  .technumopus-footer .technumopus-contact-icon {
    width: 10px;
    height: 10px;
  }

  .technumopus-footer .technumopus-social-links {
    gap: 6px;
  }

  .technumopus-footer .technumopus-social-links a svg {
    width: 14px;
    height: 14px;
  }

  .technumopus-footer .technumopus-footer-section a {
    padding: 2px 2px 2px 4px;
  }

  .technumopus-footer .technumopus-footer-bottom {
    padding-top: 12px;
    gap: 10px;
  }
}
/* ERI tagline under wordmark */
.technumopus-footer .technumopus-footer-eri {
  margin: 4px 0 18px;
  font-size: clamp(13px, 1.2vw, 15px);
  font-weight: 600;
  color: #00a896;
  line-height: 1.4;
  letter-spacing: 0.01em;
}

/* Emphasized cross-link to Onified.ai in Company column */
.technumopus-footer .technumopus-footer-onified-link {
  color: #00a896 !important;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: color 200ms ease, gap 200ms ease;
}

.technumopus-footer .technumopus-footer-onified-link:hover {
  color: #00c4ad !important;
  gap: 6px;
}

@media (max-width: 480px) {
  .technumopus-footer .technumopus-footer-eri {
    font-size: 13px;
    margin: 4px 0 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Footer/Footer.css"],"names":[],"mappings":"AAAA,WAAW;AACX,kEAAkE;AAClE;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,wDAAwD;EACxD,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,+EAA+E;EAC/E,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,sCAAsC;EACtC,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E,8CAA8C,WAAW,EAAE;;AAE3D;EACE,8CAA8C;EAC9C,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,wCAAwC;EACxC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,eAAe;;AAEf,8CAA8C;;AAE9C,6BAA6B;AAC7B;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA,yDAAyD;AACzD;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;AACA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* Footer */\n/* Color tokens now come from Technum.css (:root) as --technum-* */\n.technumopus-footer {\n  background: var(--technum-navy);\n  color: rgba(255, 255, 255, 0.8);\n  padding: var(--section-padding) var(--container-padding);\n  font-size: var(--body-regular);\n}\n\n.technumopus-footer .technumopus-container {\n  max-width: 1440px;\n  margin: 0 auto;\n}\n\n.technumopus-footer .technumopus-footer-content {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr 1.5fr;\n  gap: 48px;\n  margin-bottom: 40px;\n}\n\n.technumopus-footer .technumopus-footer-brand p {\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.technumopus-footer .technumopus-footer-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {\n  width: 200px;\n  height: auto;\n}\n\n.technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.technumopus-footer .technumopus-contact-info {\n  margin-bottom: 24px;\n  font-size: 0.8125rem;\n}\n\n.technumopus-footer .technumopus-contact-info p {\n  margin-bottom: 6px;\n  line-height: 1.5;\n}\n\n.technumopus-footer .technumopus-contact-info strong {\n  color: var(--technum-white);\n  font-weight: 600;\n}\n\n.technumopus-footer .technumopus-contact-info a {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.technumopus-footer .technumopus-contact-info a:hover {\n  color: var(--technum-teal);\n}\n\n.technumopus-footer .technumopus-contact-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.technumopus-footer .technumopus-contact-icon {\n  width: 18px;\n  height: 19px;\n  flex-shrink: 0;\n  opacity: 0.8;\n  transition: opacity 0.3s ease;\n}\n\n.technumopus-footer .technumopus-contact-item:hover .technumopus-contact-icon {\n  opacity: 1;\n}\n\n.technumopus-footer .technumopus-social-links {\n  display: flex;\n  gap: 16px;\n}\n\n.technumopus-footer .technumopus-social-links a {\n  color: rgba(255, 255, 255, 0.6);\n  transition: color 0.3s ease;\n}\n\n.technumopus-footer .technumopus-social-links a:hover {\n  color: var(--technum-white);\n}\n\n.technumopus-footer .technumopus-footer-section h4 {\n  color: var(--technum-white);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-weight: 600;\n  margin-bottom: 20px;\n  font-size: var(--body-large);\n}\n\n.technumopus-footer .technumopus-footer-section ul {\n  list-style: none;\n  line-height: 2;\n  padding: 0;\n  margin: 0;\n}\n\n.technumopus-footer .technumopus-footer-section a {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-size: var(--body-regular);\n  display: block;\n  padding: 6px 6px 6px 10px;\n  white-space: nowrap;\n  position: relative;\n  border-left: 4px solid transparent;\n}\n\n.technumopus-footer .technumopus-footer-section a:hover {\n  color: var(--technum-white);\n  background: rgba(0, 168, 150, 0.15);\n  border-left-color: var(--technum-teal);\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n/* Quick Contact Form — sizing/layout overrides; visuals live in Forms.css */\n.technumopus-footer .technumopus-quick-form { width: 100%; }\n\n.technumopus-footer .technumopus-footer-aws {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px 0;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.technumopus-footer .technumopus-footer-aws-left {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.technumopus-footer .technumopus-footer-aws-logo {\n  height: 36px;\n  width: auto;\n  flex-shrink: 0;\n  filter: brightness(0) invert(1);\n  opacity: 0.95;\n}\n\n.technumopus-footer .technumopus-footer-aws-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.technumopus-footer .technumopus-footer-aws-title {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--technum-white);\n  letter-spacing: 0.01em;\n}\n\n.technumopus-footer .technumopus-footer-aws-desc {\n  font-size: 0.8125rem;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.5;\n}\n\n.technumopus-footer .technumopus-footer-aws-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: 999px;\n  background: rgba(0, 168, 150, 0.12);\n  border: 1px solid rgba(0, 168, 150, 0.4);\n  color: var(--technum-white);\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background 0.3s ease, border-color 0.3s ease, transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.technumopus-footer .technumopus-footer-aws-cta:hover {\n  background: rgba(0, 168, 150, 0.22);\n  border-color: rgba(0, 168, 150, 0.7);\n  transform: translateX(2px);\n}\n\n@media (max-width: 600px) {\n  .technumopus-footer .technumopus-footer-aws {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .technumopus-footer .technumopus-footer-aws-cta {\n    align-self: stretch;\n    justify-content: center;\n  }\n}\n\n.technumopus-footer .technumopus-footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.technumopus-footer .technumopus-footer-bottom p {\n  font-size: var(--body-small);\n  margin: 0;\n}\n\n.technumopus-footer .technumopus-footer-links {\n  display: flex;\n  gap: 12px;\n  font-size: var(--body-small);\n}\n\n.technumopus-footer .technumopus-footer-links a {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  padding: 2px 8px;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.technumopus-footer .technumopus-footer-links a:hover {\n  color: var(--technum-white);\n  background: rgba(0, 168, 150, 0.1);\n}\n\n/* Responsive */\n\n/* Large Laptops/Desktops (1440px and above) */\n\n/* Tablets (769px - 1024px) */\n@media (max-width: 1024px) {\n  .technumopus-footer .technumopus-container {\n    padding: 0 var(--container-padding);\n  }\n\n  .technumopus-footer .technumopus-footer-content {\n    grid-template-columns: 1fr 1fr;\n    gap: 32px;\n    margin-bottom: 32px;\n  }\n\n  .technumopus-footer .technumopus-footer-brand {\n    grid-column: span 2;\n  }\n\n  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {\n    width: 160px;\n  }\n\n  .technumopus-footer .technumopus-contact-icon {\n    width: 16px;\n    height: 16px;\n  }\n\n  .technumopus-footer .technumopus-social-links {\n    gap: 12px;\n  }\n\n  .technumopus-footer .technumopus-social-links a svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .technumopus-footer .technumopus-footer-section a {\n    padding: 5px 5px 5px 8px;\n  }\n\n  .technumopus-footer .technumopus-footer-bottom {\n    padding-top: 24px;\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n/* Mobile Landscape and Smaller Tablets (481px - 768px) */\n@media (max-width: 768px) {\n  .technumopus-footer .technumopus-container {\n    padding: 0 var(--container-padding);\n  }\n\n  .technumopus-footer .technumopus-footer-content {\n    grid-template-columns: 1fr;\n    gap: 24px;\n    margin-bottom: 24px;\n  }\n\n  .technumopus-footer .technumopus-footer-brand {\n    grid-column: span 1;\n  }\n\n  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {\n    width: 140px;\n  }\n\n  .technumopus-footer .technumopus-contact-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  .technumopus-footer .technumopus-social-links {\n    gap: 10px;\n  }\n\n  .technumopus-footer .technumopus-social-links a svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .technumopus-footer .technumopus-footer-section a {\n    padding: 4px 4px 4px 6px;\n  }\n\n  .technumopus-footer .technumopus-footer-bottom {\n    padding-top: 20px;\n  }\n}\n\n/* Mobile Portrait (480px and below) */\n@media (max-width: 480px) {\n  .technumopus-footer .technumopus-container {\n    padding: 0 var(--container-padding);\n  }\n\n  .technumopus-footer .technumopus-footer-content {\n    gap: 20px;\n    margin-bottom: 20px;\n  }\n\n  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {\n    width: 120px;\n  }\n\n  .technumopus-footer .technumopus-contact-icon {\n    width: 12px;\n    height: 12px;\n  }\n\n  .technumopus-footer .technumopus-social-links {\n    gap: 8px;\n  }\n\n  .technumopus-footer .technumopus-social-links a svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  .technumopus-footer .technumopus-footer-section a {\n    padding: 3px 3px 3px 5px;\n  }\n\n  .technumopus-footer .technumopus-footer-bottom {\n    padding-top: 16px;\n    gap: 12px;\n  }\n}\n\n/* Small Mobile Phones (360px and below) */\n@media (max-width: 360px) {\n  .technumopus-footer .technumopus-container {\n    padding: 0 var(--container-padding);\n  }\n\n  .technumopus-footer .technumopus-footer-content {\n    gap: 16px;\n    margin-bottom: 16px;\n  }\n\n  .technumopus-footer .technumopus-footer-logo .technumopus-logo-wrapper {\n    width: 100px;\n  }\n\n  .technumopus-footer .technumopus-contact-icon {\n    width: 10px;\n    height: 10px;\n  }\n\n  .technumopus-footer .technumopus-social-links {\n    gap: 6px;\n  }\n\n  .technumopus-footer .technumopus-social-links a svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .technumopus-footer .technumopus-footer-section a {\n    padding: 2px 2px 2px 4px;\n  }\n\n  .technumopus-footer .technumopus-footer-bottom {\n    padding-top: 12px;\n    gap: 10px;\n  }\n}\n/* ERI tagline under wordmark */\n.technumopus-footer .technumopus-footer-eri {\n  margin: 4px 0 18px;\n  font-size: clamp(13px, 1.2vw, 15px);\n  font-weight: 600;\n  color: #00a896;\n  line-height: 1.4;\n  letter-spacing: 0.01em;\n}\n\n/* Emphasized cross-link to Onified.ai in Company column */\n.technumopus-footer .technumopus-footer-onified-link {\n  color: #00a896 !important;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: color 200ms ease, gap 200ms ease;\n}\n\n.technumopus-footer .technumopus-footer-onified-link:hover {\n  color: #00c4ad !important;\n  gap: 6px;\n}\n\n@media (max-width: 480px) {\n  .technumopus-footer .technumopus-footer-eri {\n    font-size: 13px;\n    margin: 4px 0 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
